<template>
  <div class="plat-data-grid-site"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="sites">
      <template v-if="sites.length">
        <keep-alive>
          <TemplateDataGrid :key="site"
                            ref="grid"
                            :gridId="gridId"
                            v-bind="gridParams"
                            v-on="$listeners">
            <template #title="{title}">
              <div class="plat-data-grid-site-header">
                <span v-if="showLabel"
                      class="custom-label">选择教学点</span>
                <template v-if="group">
                  <el-cascader v-model="site"
                               size="mini"
                               :options="groupSites"
                               :props="groupProps"></el-cascader>
                </template>
                <template v-else>
                  <el-select v-model="site"
                             size="mini"
                             filterable>
                    <el-option v-for="site in sites"
                               :key="site.id"
                               :label="site.name"
                               :value="site.id"/>
                  </el-select>
                </template>
                <span v-if="showTitle"
                      class="custom-title">{{title}}</span>
                <div v-if="$slots.append"
                     class="append">
                  <slot name="append"></slot>
                </div>
              </div>
            </template>
          </TemplateDataGrid>
        </keep-alive>
      </template>
      <template v-else>
        <Hint type="empty">
          <div>教学点数据为空</div>
        </Hint>
      </template>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>教学点数据加载失败</div>
        <el-button type="text"
                   @click="loadSites">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import TemplateDataGrid from '../../../../../templates/TemplateDataGrid'
import Hint from '../../../../../elements/Hint'
import Wrapper from '../../../../../../mixins/grid/wrapper'
export default {
  name: 'PlatDataGridSite',
  mixins: [Wrapper],
  components: {
    TemplateDataGrid,
    Hint
  },
  props: {
    showLabel: Boolean,
    showTitle: {
      type: Boolean,
      default: true
    },
    group: Boolean,
    extraParams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      sites: null,
      siteUnits: null,
      site: '',
      groupProps: {
        label: 'name',
        value: 'id',
        emitPath: false
      }
    }
  },
  computed: {
    gridParams () {
      return Object.assign({}, this.extraParams, {
        site: this.site
      })
    },
    groupSites () {
      let siteUnits = this.siteUnits
      let sites = this.sites
      if (siteUnits && sites) {
        return siteUnits.map(siteUnit => {
          let children = sites.filter(site => site.siteUnit === siteUnit.code)
          return this.$extend({
            children
          }, siteUnit)
        })
      }
      return []
    }
  },
  methods: {
    loadSites () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/portal/data/select/sites',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.sites = response.data['sites'] || []
          this.siteUnits = response.data['siteUnits'] || []
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    loadGridData () {
      this.$nextTick(() => {
        let grid = this.$refs.grid
        if (grid) {
          grid.loadGridData()
        }
      })
    }
  },
  mounted () {
    this.loadSites()
  },
  watch: {
    sites: function (val) {
      if (val && val.length) {
        let getSite
        let lastSiteId = this.getWrapper('site')
        if (lastSiteId) {
          getSite = val.find(site => site.id === lastSiteId)
        }
        if (getSite) {
          this.site = getSite.id
        } else {
          this.site = val[0].id
        }
      }
    },
    site: function (val) {
      this.setWrapper('site', val)
    },
    gridParams: {
      handler: function () {
        this.loadGridData()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  .plat-data-grid-site {
    height: 100%;
    .plat-data-grid-site-header {
      display: inline-flex;
      align-items: center;
      .el-cascader {
        width: 260px;
      }
      .el-select {
        width: 180px;
      }
      .custom-label {
        margin-right: 8px;
        font-size: 13px;
      }
      .custom-title {
        margin-left: 8px;
        font-size: 13px;
      }
    }
  }
</style>
